import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    },
    {
      path:'/userPage',
      name: 'userPage',
      component: () => import(/* webpackChunkName: "userPage" */ './views/UserPage.vue')
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue')
    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/patients',
      name: 'patients',
      component: () => import(/* webpackChunkName: "patients" */ './views/Patients.vue')
    },
    {
      path: '/patientPage/:patient_id',
      name: 'patientPage',
      component: () => import(/* webpackChunkName: "patientPage" */ './views/PatientPage.vue'),
      props: true
    },
    {
      path: '/editPatient/:patient_id',
      name: 'editPatient',
      component: () => import(/* webpackChunkName: "editPatientPage" */ './views/EditPatient.vue'),
      props: true
    },
    {
      path: '/registerPatient/',
      name: 'registerPatient',
      component: () => import(/* webpackChunkName: "registerPatientPage" */ './views/RegisterPatient.vue')
    },
    {
      path: '/editTest/:patientId/:testPackId',
      name: 'editTest',
      props: true,
      component: () => import(/* webpackChunkName: "editTestPage" */ './views/EditTest.vue')
    },
    {
      path: '/statsPage/',
      name: 'statsPage',
      component: () => import(/* webpackChunkName: "editTestPage" */ './views/StatsPage.vue')
    },
    {
      path: '/adminPage/',
      name: 'adminPage',
      component: () => import(/* webpackChunkName: "editTestPage" */ './views/AdminPage.vue')
    },
    {
      path: '/notFound',
      name: 'notFound',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/NotFound.vue')
    },
    { 
      path: '*',
      redirect: 'notFound'
    }
  ]
})

router.beforeEach((to, from, next) => {
  console.log(to)
  if(to.name != 'login'){
    if (store.getters.getUserLoggedIn){
      next()
    } else {
      next({
        name: 'login',
        query: { location: "about" }
      })
    }
  } else {
    next();
  }
})

export default router
